import {useCallback, useEffect, useState} from "react";
import useAcquiredToken from "./useAcquiredToken";
import {AccountHealthReport} from "../domain/AccountHealthReport";
import {Simulate} from "react-dom/test-utils";
import ended = Simulate.ended;

const useGASonDemand = () => {
    const { accessToken, loading: authLoading, error: authError, acquireToken } = useAcquiredToken();
    const [data, setData] = useState<AccountHealthReport | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [endpoint, setEndpoint] = useState<string>("");
    const [method, setMethod] = useState<string>("GET");

    const fetchData = useCallback(async (endpoint:string, method = "GET") => {
        if (!endpoint) {
            return;
        }

        setEndpoint(endpoint);
        setMethod(method);

        if (authLoading) {
            return;
        }  // Prevent API call if auth is still loading
        if (!accessToken) {
            return;
        }  // Prevent API call if no access token

        setLoading(true);
        setError(null);

        const fetchOptions = {
            method: method,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const fullUrl = `${process.env.REACT_APP_GAS_URL}${endpoint}`;
        console.log(fullUrl);

        try {
            const response = await fetch(fullUrl, fetchOptions);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            setData(result);
            setLoading(false);
        } catch (err:any) {
            setLoading(false);
            if (err.message.includes('Failed to acquire token silently')) {
                // Optionally retry acquiring the token and the request
                console.error('Token acquisition failed:', err.message);
                await acquireToken(); // Retry acquiring token
                await fetchData(fullUrl, method); // Retry fetching data
            } else {
                console.log(err.message);
                setError('Error fetching data: ' + err.message);
            }
        }
    },[accessToken]);

    // // Fetch data when accessToken changes or on demand
    useEffect(() => {
        if (accessToken) {
            fetchData(endpoint, method);
        }
    }, [accessToken, acquireToken]);

    return { data, error, loading, fetchData };
};

export default useGASonDemand;
